import { Box, BoxProps, smBumps, Typo, TypoSizeProps } from '@wrisk/ui-components'
import React from 'react'

import { getInsuredProfile, Quote } from '../../../../domain'
import { useIncludedCovers } from '../../../../hooks/covers'
import {
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { useProduct } from '../../productContext'

interface ExcessEndorsementsProps extends BoxProps, TypoSizeProps {
  quote: Quote
}

const tKey = TKey('components.excess-endorsements')

export const ExcessEndorsements: React.FC<ExcessEndorsementsProps> = ({
  quote,
  typoSize,
  ...props
}) => {
  const { t } = useWriskTranslation()

  const { product } = useProduct()

  const endorsementCovers = useIncludedCovers(quote, product).map((it) => it.coverCode)
  const endorsements = quote.endorsements.filter(
    (it) => !endorsementCovers.includes(it.code),
  )

  return endorsements.length ? (
    <Box {...props}>
      {endorsements.map((it, index) => {
        const data = getInsuredProfile(quote, it.profileCode)?.data

        return data ? (
          <Box
            data-testid={`${it.code} ${it.profileCode}`}
            key={index}
            mt={index ? smBumps : 0}
            pl={smBumps}
            borderLeftWidth='3px'
            borderColor='surfaceWarning'
          >
            <Typo typoSize={typoSize}>
              {t(tKey(it.code), { nameOfDriver: `${data.firstName} ${data.lastName}` })}
            </Typo>
          </Box>
        ) : null
      })}
    </Box>
  ) : null
}
